"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleContext = void 0;
const react_1 = require("react");
exports.LocaleContext = (0, react_1.createContext)('en_US');
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9jYWxlQ29udGV4dFByb3ZpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbXBvbmVudHMvTG9jYWxlQ29udGV4dFByb3ZpZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpQ0FBc0M7QUFFekIsUUFBQSxhQUFhLEdBQUcsSUFBQSxxQkFBYSxFQUFTLE9BQU8sQ0FBQyxDQUFDIn0=